import { render, staticRenderFns } from "./uploadimg.vue?vue&type=template&id=0d464ffa&"
import script from "./uploadimg.vue?vue&type=script&lang=js&"
export * from "./uploadimg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports